/**
 * Shared filter options for Statistics module
 */

export const PROVINCE_OPTIONS = [
  { value: 'Hà Nội', label: 'Hà Nội' },
  { value: 'TP Hồ Chí Minh', label: 'TP Hồ Chí Minh' },
  { value: 'Đà Nẵng', label: 'Đà Nẵng' },
  { value: 'Hải Phòng', label: 'Hải Phòng' },
  { value: 'Cần Thơ', label: 'Cần Thơ' },
  { value: 'An Giang', label: 'An Giang' },
  { value: 'Bà Rịa - Vũng Tàu', label: 'Bà Rịa - Vũng Tàu' },
  { value: 'Bắc Giang', label: 'Bắc Giang' },
  { value: 'Bắc Kạn', label: 'Bắc Kạn' },
  { value: 'Bạc Liêu', label: 'Bạc Liêu' },
  { value: 'Bắc Ninh', label: 'Bắc Ninh' },
  { value: 'Bến Tre', label: 'Bến Tre' },
  { value: 'Bình Định', label: 'Bình Định' },
  { value: 'Bình Dương', label: 'Bình Dương' },
  { value: 'Bình Phước', label: 'Bình Phước' },
  { value: 'Bình Thuận', label: 'Bình Thuận' },
  { value: 'Cà Mau', label: 'Cà Mau' },
  { value: 'Cao Bằng', label: 'Cao Bằng' },
  { value: 'Đắk Lắk', label: 'Đắk Lắk' },
  { value: 'Đắk Nông', label: 'Đắk Nông' },
  { value: 'Điện Biên', label: 'Điện Biên' },
  { value: 'Đồng Nai', label: 'Đồng Nai' },
  { value: 'Đồng Tháp', label: 'Đồng Tháp' },
  { value: 'Gia Lai', label: 'Gia Lai' },
  { value: 'Hà Giang', label: 'Hà Giang' },
  { value: 'Hà Nam', label: 'Hà Nam' },
  { value: 'Hà Tĩnh', label: 'Hà Tĩnh' },
  { value: 'Hải Dương', label: 'Hải Dương' },
  { value: 'Hậu Giang', label: 'Hậu Giang' },
  { value: 'Hòa Bình', label: 'Hòa Bình' },
  { value: 'Hưng Yên', label: 'Hưng Yên' },
  { value: 'Khánh Hòa', label: 'Khánh Hòa' },
  { value: 'Kiên Giang', label: 'Kiên Giang' },
  { value: 'Kon Tum', label: 'Kon Tum' },
  { value: 'Lai Châu', label: 'Lai Châu' },
  { value: 'Lâm Đồng', label: 'Lâm Đồng' },
  { value: 'Lạng Sơn', label: 'Lạng Sơn' },
  { value: 'Lào Cai', label: 'Lào Cai' },
  { value: 'Long An', label: 'Long An' },
  { value: 'Nam Định', label: 'Nam Định' },
  { value: 'Nghệ An', label: 'Nghệ An' },
  { value: 'Ninh Bình', label: 'Ninh Bình' },
  { value: 'Ninh Thuận', label: 'Ninh Thuận' },
  { value: 'Phú Thọ', label: 'Phú Thọ' },
  { value: 'Phú Yên', label: 'Phú Yên' },
  { value: 'Quảng Bình', label: 'Quảng Bình' },
  { value: 'Quảng Nam', label: 'Quảng Nam' },
  { value: 'Quảng Ngãi', label: 'Quảng Ngãi' },
  { value: 'Quảng Ninh', label: 'Quảng Ninh' },
  { value: 'Quảng Trị', label: 'Quảng Trị' },
  { value: 'Sóc Trăng', label: 'Sóc Trăng' },
  { value: 'Sơn La', label: 'Sơn La' },
  { value: 'Tây Ninh', label: 'Tây Ninh' },
  { value: 'Thái Bình', label: 'Thái Bình' },
  { value: 'Thái Nguyên', label: 'Thái Nguyên' },
  { value: 'Thanh Hóa', label: 'Thanh Hóa' },
  { value: 'Thừa Thiên Huế', label: 'Thừa Thiên Huế' },
  { value: 'Tiền Giang', label: 'Tiền Giang' },
  { value: 'Trà Vinh', label: 'Trà Vinh' },
  { value: 'Tuyên Quang', label: 'Tuyên Quang' },
  { value: 'Vĩnh Long', label: 'Vĩnh Long' },
  { value: 'Vĩnh Phúc', label: 'Vĩnh Phúc' },
  { value: 'Yên Bái', label: 'Yên Bái' },
  { value: 'none', label: 'Không có thông tin' },
];

export const ALL_PROVINCE_OPTIONS = [
  ...PROVINCE_OPTIONS.filter((p) => p.value !== 'none'),
  { value: 'NO_INFO', label: 'Không có thông tin' },
];

export const GENDER_OPTIONS = [
  { value: 'Nam', label: 'Nam' },
  { value: 'Nữ', label: 'Nữ' },
  { value: 'none', label: 'Không có thông tin' },
];

export const AGE_GROUP_OPTIONS = [
  { value: '0_7m', label: 'Từ 0 - dưới 7 tháng tuổi' },
  { value: '7_9m', label: 'Từ 7 - dưới 9 tháng tuổi' },
  { value: '9_12m', label: 'Từ 9 - dưới 12 tháng tuổi' },
  { value: '12_18m', label: 'Từ 12 - dưới 18 tháng tuổi' },
  { value: '18_24m', label: 'Từ 18 - dưới 24 tháng tuổi' },
  { value: '24_36m', label: 'Từ 24 - dưới 36 tháng tuổi' },
  { value: '36_60m', label: 'Từ 36 - dưới 60 tháng tuổi' },
  { value: '60_72m', label: 'Từ 60 - dưới 72 tháng tuổi' },
  { value: '72m_8y', label: 'Từ 72 tháng - dưới 8 tuổi' },
  { value: '8_10y', label: 'Từ 8 - dưới 10 tuổi' },
  { value: '10_12y', label: 'Từ 10 - dưới 12 tuổi' },
  { value: '12_15y', label: 'Từ 12 - dưới 15 tuổi' },
  { value: '15_19y', label: 'Từ 15 - tròn 19 tuổi' },
  { value: '19_20y', label: 'Từ trên 19 - dưới 20 tuổi' },
  { value: '20_30y', label: 'Từ 20 - dưới 30 tuổi' },
  { value: '30y', label: '30 tuổi' },
  { value: '31_50y', label: 'Từ 31 - dưới 50 tuổi' },
  { value: '50_70y', label: 'Từ 50 - dưới 70 tuổi' },
  { value: '70y_plus', label: 'Từ ≥70 tuổi' },
  { value: 'none', label: 'Không có thông tin' },
];

export const AGE_GROUPS_OPTIONS = [
  { value: 'AGE_0_7M', label: 'Từ 0 - dưới 7 tháng tuổi' },
  { value: 'AGE_7_9M', label: 'Từ 7 – dưới 9 tháng tuổi' },
  { value: 'AGE_9_12M', label: 'Từ 9 – dưới 12 tháng tuổi' },
  { value: 'AGE_12_18M', label: 'Từ 12 – dưới 18 tháng tuổi' },
  { value: 'AGE_18_24M', label: 'Từ 18 – dưới 24 tháng tuổi' },
  { value: 'AGE_24_36M', label: 'Từ 24 – dưới 36 tháng tuổi' },
  { value: 'AGE_36_60M', label: 'Từ 36 – dưới 60 tháng tuổi' },
  { value: 'AGE_60_72M', label: 'Từ 60 – dưới 72 tháng tuổi' },
  { value: 'AGE_72M_8Y', label: 'Từ 72 tháng – dưới 8 tuổi' },
  { value: 'AGE_8_10Y', label: 'Từ 8 – dưới 10 tuổi' },
  { value: 'AGE_10_12Y', label: 'Từ 10 – dưới 12 tuổi' },
  { value: 'AGE_12_15Y', label: 'Từ 12 – dưới 15 tuổi' },
  { value: 'AGE_15_19Y', label: 'Từ 15 – tròn 19 tuổi' },
  { value: 'AGE_19_20Y', label: 'Từ trên 19 tuổi - dưới 20 tuổi' },
  { value: 'AGE_20_30Y', label: 'Từ 20 - dưới 30 tuổi' },
  { value: 'AGE_30Y', label: '30 tuổi' },
  { value: 'AGE_31_50Y', label: 'Từ 31 - dưới 50 tuổi' },
  { value: 'AGE_50_70Y', label: 'Từ 50 - dưới 70 tuổi' },
  { value: 'AGE_GE_70Y', label: 'Từ ≥70 tuổi' },
  { value: 'NO_INFO', label: 'Không có thông tin' },
];

export const FEATURE_OPTIONS = [
  { value: 'HOME', label: 'Trang chủ' },
  { value: 'HEALTH_MONITORING', label: 'Theo dõi sức khỏe' },
  { value: 'HEALTH_CONSULT', label: 'Tư vấn sức khỏe' },
  { value: 'MEAL_PLANNER', label: 'Kiểm tra & Lên bữa ăn' },
  { value: 'HEALTH_DIARY', label: 'Nhật ký sức khỏe' },
  { value: 'GOALS', label: 'Mục tiêu của bạn' },
  { value: 'HANDBOOK', label: 'Cẩm nang cho bạn' },
  { value: 'OTHER', label: 'Khác' },
];

export const DEVICE_OPTIONS = [
  { value: 'MOBILE', label: 'Mobile' },
  { value: 'TABLET', label: 'Tablet' },
  { value: 'DESKTOP', label: 'Desktop' },
];

export const FREQUENCY_RANGE_OPTIONS = [
  { value: '1_2', label: '1 - 2 lần' },
  { value: '3_4', label: '3 - 4 lần' },
  { value: '5_6', label: '5 - 6 lần' },
  { value: '7_10', label: '7 - 10 lần' },
  { value: '10_14', label: '10 - 14 lần' },
  { value: '14_30', label: '14 - 30 lần' },
  { value: '30_60', label: '30 - 60 lần' },
  { value: '>60', label: '> 60 lần' },
];
